import React, { useState, useEffect } from "react";

import { Button, Icon, Popup } from "semantic-ui-react";

import { useIntl } from "react-intl";

import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

// Common
import ErrorMessage from "react-lib/apps/common/ErrorMessage";

// UX
import ModChangePasswordUX from "./ModChangePasswordUX";

type ModChangePasswordProps = {
  onEvent: (e: any) => void;
  setProp: (key: any, value: any, callback?: () => void) => any;
  changePassword?: Record<string, any>;
  languageUX?: string;
  pw2CheckTeacherFlag?: boolean;
  showPassword2?: boolean;
  user?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  successMessage?: Record<string, any>;
  onApprovalPasswordSuccess?: (isApprove: boolean) => void;
  onClose: () => any;
};

// Const
const BUTTON_ACTIONS = {
  save: "SAVE",
};

const CARD_CHANGE_PASSWORD = "ModChangePasswordUX";

const ACTION_SAVE = `${CARD_CHANGE_PASSWORD}_${BUTTON_ACTIONS.save}`;

const ModChangePassword = (props: ModChangePasswordProps) => {
  const intl = useIntl();
  const [isChangePass1, setIsChangePass1] = useState<boolean>(false);
  const [isChangeConPass1, setIsChangeConPass1] = useState<boolean>(false);
  const [isChangePass2, setIsChangePass2] = useState<boolean>(false);
  const [isChangeConPass2, setIsChangeConPass2] = useState<boolean>(false);

  const [showChangePass1, setShowChangePass1] = useState<boolean>(false);
  const [showChangePass2, setShowChangePass2] = useState<boolean>(false);
  const [isApprovalPassword, setIsApprovalPassword] = useState<boolean | undefined>(false);

  useEffect(() => {
    if (!props.successMessage?.[CARD_CHANGE_PASSWORD]) {
      return;
    }

    handleOnCancel();

    setShowChangePass1(false);
    setShowChangePass2(false);
  }, [props.successMessage?.[CARD_CHANGE_PASSWORD]]);

  useEffect(() => {
    setIsApprovalPassword(props.user?.use_sec_pass_for_approve);
  }, [props.user]);

  const handleClear = () => {
    props.setProp("changePassword", null);
    props.setProp(`errorMessage.${CARD_CHANGE_PASSWORD}`, null);
    props.setProp(`successMessage.${CARD_CHANGE_PASSWORD}`, null);
  };

  const handleOnCancel = () => {
    handleClear();

    props.onClose();
  };

  const handleChangeApprovalPassword = (checked: boolean) => {
    setIsApprovalPassword(checked);
  };

  const handleChangePassword = () => {
    props.onEvent({
      message: "SettingStaff",
      params: {
        action: "CHANGE_PASSWORD",
        id: props.user?.id,
        buttonLoadKey: ACTION_SAVE,
        card: CARD_CHANGE_PASSWORD,
        changePass1: showChangePass1,
        changePass2: showChangePass2,
        ...(isApprovalPassword !== props.user?.use_sec_pass_for_approve && {
          approvalPassword: isApprovalPassword,
          onApprovalPasswordSuccess: props.onApprovalPasswordSuccess,
        }),
      },
    });
  };

  const changeValue = (key: string) => (e: any, v: any) => {
    const value: string = v.value;

    if (key.includes("password2")) {
      // 123456
      if (!value || value.search(/^\d+$/) >= 0) {
        props.setProp(`changePassword.${key}`, value.slice(0, 6));
      }
    } else {
      props.setProp(`changePassword.${key}`, value);
    }
  };

  const handleClickChangePass2 = () => {
    if (!props.showPassword2) {
      return;
    }

    handleClear();

    setShowChangePass2(!showChangePass2);
  };

  return (
    <ModChangePasswordUX
      approvalPassword={isApprovalPassword}
      // callback
      changeValue={changeValue}
      confirm_password1={props.changePassword?.confirm_password1}
      confirm_password2={props.changePassword?.confirm_password2}
      // Element
      ErrorMessages={<ErrorMessage error={props.errorMessage?.[CARD_CHANGE_PASSWORD]?.error} />}
      languageUX={props.languageUX}
      OnCancel={handleOnCancel}
      password1={props.changePassword?.password1}
      password2={props.changePassword?.password2}
      pw2CheckTeacherFlag={props.pw2CheckTeacherFlag}
      showChangePass1={showChangePass1}
      showChangePass2={showChangePass2}
      // config
      showPassword2={props.showPassword2}
      typeConfirm1={isChangeConPass1 ? "" : "password"}
      typeConfirm2={isChangeConPass2 ? "" : "password"}
      typePassword1={isChangePass1 ? "" : "password"}
      typePassword2={isChangePass2 ? "" : "password"}
      // data
      username={props.user?.username}
      onChangeApprovalPassword={handleChangeApprovalPassword}
      buttonSave={
        <ButtonLoadCheck
          // function
          setProp={props.setProp}
          // config
          color="green"
          name="SAVE"
          // data
          paramKey={ACTION_SAVE}
          style={{ width: "100%" }}
          title={intl.formatMessage({ id: "บันทึก" })}
          buttonLoadCheck={props.buttonLoadCheck?.[ACTION_SAVE]}
          onClick={handleChangePassword}
        />
      }
      changePass1={
        <span
          aria-hidden="true"
          onClick={() => {
            handleClear();

            setShowChangePass1(!showChangePass1);
          }}
          style={{
            color: showChangePass1 ? "red" : "#2185D0",
            cursor: "pointer",
          }}
        >
          {showChangePass1 ? "ยกเลิก" : "เปลี่ยนรหัสผ่าน"}
        </span>
      }
      changePass2={
        <span
          aria-hidden="true"
          onClick={handleClickChangePass2}
          style={{
            color: showChangePass2 ? "red" : "#2185D0",
            cursor: "pointer",
          }}
        >
          {showChangePass2 ? "ยกเลิก" : "เปลี่ยนรหัสผ่าน"}
        </span>
      }
      eyeConfirm1={
        <Icon
          name={isChangeConPass1 ? "eye" : "eye slash"}
          link
          onClick={() => {
            setIsChangeConPass1(!isChangeConPass1);
          }}
        />
      }
      eyeConfirm2={
        <Icon
          name={isChangeConPass2 ? "eye" : "eye slash"}
          link
          onClick={() => {
            setIsChangeConPass2(!isChangeConPass2);
          }}
        />
      }
      eyePass1={
        <Icon
          name={isChangePass1 ? "eye" : "eye slash"}
          link
          onClick={() => {
            setIsChangePass1(!isChangePass1);
          }}
        />
      }
      eyePass2={
        <Icon
          name={isChangePass2 ? "eye" : "eye slash"}
          link
          onClick={() => {
            setIsChangePass2(!isChangePass2);
          }}
        />
      }
      InfoPopup={
        <Popup
          position="right center"
          content={intl.formatMessage({
            id: "กำหนดผ่านรหัสผ่านชุดที่ 2 ด้วยตัวเลข 0-9 จำนวน 6 ตัว",
          })}
          trigger={
            <Button
              color="blue"
              icon="info"
              size="mini"
              style={{ marginLeft: "0.55rem", padding: "0.15rem 0.2rem" }}
              circular
            />
          }
        />
      }
      //
      passwordNote={
        <div style={{ marginLeft: "10px" }}>
          {"สำหรับ log-in เข้าใช้งาน / Approve งาน (ต้องเป็น"}
          <span
            style={{
              textDecoration: "underline",
              textDecorationColor: "lightgrey",
              textDecorationThickness: "1px",
              textUnderlineOffset: "3px",
            }}
          >
            อาจารย์
          </span>
          {"เท่านั้น)"}{" "}
        </div>
      }
    />
  );
};

ModChangePassword.displayName = "ModChangePassword";

export default React.memo(ModChangePassword);
